<template>
  <td colspan="11" class="expand">
    <!-- =========================== Control =========================== -->
    <div class="flex justify-between items-center p-2">
      <p class="title text-sm">{{getSubTitle}}</p>
      <div v-if="!readonly && !isPrint">
        <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
        <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
      </div>
    </div>
    <!-- =========================== Expand Content =========================== -->
    <table>
      <thead>
        <th v-if="!readonly && !isPrint"><vs-checkbox :value="this.expand.length !== 0 && this.expand.length === this.checked.length" @change="onChangeAllCheck" /></th>
        <th>No.</th>
        <th>{{getInput1Title}}</th>
        <th>{{getInput2Title}}</th>
        <th>{{getInput3Title}}</th>
        <th>{{getInput4Title}}</th>
      </thead>
      <tbody>
        <tr v-for="(_expand, _expand_i) in expand" :key="`expand_${parentsI}_${_expand_i}`">
          <td v-if="!readonly && !isPrint"><vs-checkbox v-model="checked" :vs-value="_expand_i" /></td>
          <td class="text-center">{{ parentsI + 1 }} - {{ _expand_i + 1 }}</td>
          <td>
            <p v-if="isPrint" class="print-input">{{ _expand.input_1 }}</p>
            <ml-input v-else :readonly="readonly" class="w-full flex-1" v-model="_expand.input_1" placeholder="내용" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ _expand.input_2 }}</p>
            <ml-input v-else :readonly="readonly" class="w-full flex-1" v-model="_expand.input_2" placeholder="내용" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ _expand.input_3 }}</p>
            <ml-input v-else :readonly="readonly" class="w-full flex-1" v-model="_expand.input_3" placeholder="내용" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ _expand.input_4 }}</p>
            <ml-input v-else :readonly="readonly" class="w-full flex-1" v-model="_expand.input_4" placeholder="내용" />
          </td>
        </tr>
      </tbody>
    </table>
  </td>
</template>

<script>
export default {
  props: {
    readonly: Boolean,
    isPrint: Boolean,
    parentsI: Number,
    value: Array,
    subTitle: {
      type: String,
      default: ''
    },
    input1Title: {
      type: String,
      default: ''
    },
    input2Title: {
      type: String,
      default: ''
    },
    input3Title: {
      type: String,
      default: ''
    },
    input4Title: {
      type: String,
      default: ''
    },
  },
  watch: {
    value: {
      handler(value) {
        this.expand = value;
      },
    },
    expand: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      expand: this.value,
      checked: [],
    };
  },
  methods: {
    addRow() {
      this.expand.push({});
    },
    deleteRow() {
      // this.expand.splice(index, 1);
      this.expand = this.expand.filter((ifd, ifd_i) => {
        return !this.checked.includes(ifd_i);
      });
      this.checked = [];
    },
    onChangeAllCheck() {
      if (this.checked.length !== this.expand.length) {
        this.checked = this.expand.map((e, i) => i);
      } else this.checked = [];
    },
  },
  computed: {
    getSubTitle() {
      return this.subTitle === ''? '시스템 사용자 정보': this.subTitle
    },
    getInput1Title() {
      return this.input1Title === ''? '사용자명': this.input1Title
    },
    getInput2Title() {
      return this.input2Title === ''? '사용자 ID': this.input2Title
    },
    getInput3Title() {
      return this.input3Title === ''? '연락처': this.input3Title
    },
    getInput4Title() {
      return this.input4Title === ''? '이메일': this.input4Title
    },

  }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 18px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0px;
    border-radius: 100%;
  }

  & > span {
    color: #696d71;
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: #f9f9f9;

  &,
  th,
  td {
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }

  th {
    text-align: center;
    padding: 16px 6px;
  }

  td {
    padding: 6px;
  }
}

.expand {
  background: #fff;
  padding: 0px;
  padding-bottom: 30px;
  table tbody {
    background: #fff;
  }
}
</style>
